import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { useCanonicalUrl } from "shared/hooks";

import { PageSeo } from "scmp-app/components/meta";
import type { defaultPagesSeoPage$key } from "scmp-app/queries/__generated__/defaultPagesSeoPage.graphql";

type Props = {
  reference: defaultPagesSeoPage$key;
};

export const DefaultPageSeo: FunctionComponent<Props> = ({ reference }) => {
  const page = useFragment(
    graphql`
      fragment defaultPagesSeoPage on Page {
        headline
        urlAlias
      }
    `,
    reference,
  );
  const { canonicalUrl } = useCanonicalUrl(page.urlAlias);
  const description =
    "Your source for credible news and authoritative insights from Hong Kong, China and the world.";

  return (
    <PageSeo
      canonical={canonicalUrl}
      description={description}
      openGraph={{
        description,
        url: canonicalUrl,
      }}
      title={page.headline ?? ""}
    />
  );
};

DefaultPageSeo.displayName = "DefaultPageSeo";
